// @ts-check
import { useCallback, useEffect, useRef } from 'react'
import styles from './Overlay.module.css'

/** @typedef {{ children: React.ReactNode, onClick?: () => void, dismissible?: boolean, zIndex?: number }} Props */
/** @param {Props} props */
export default function Overlay({ children, onClick, dismissible = true, zIndex = 100 }) {
  const popover = useRef(/** @type {HTMLDivElement | null} */ (null))

  const onClickHandler = useCallback(
    /**
     * @param {Event} event
     */
    (event) => {
      if (!dismissible || !onClick) {
        return
      }
      // check if the overlay itself (outside the modal) was clicked
      if (popover.current && popover.current === event.composedPath()[0]) {
        onClick()
      }
    },
    [dismissible, onClick]
  )

  useEffect(() => {
    document.body.style.position = 'fixed'
    document.body.style.top = `-${Math.round(window.scrollY)}px`
    document.body.style.right = '0px'
    document.body.style.left = '0px'
    if (dismissible && onClick) {
      document.body.addEventListener('click', onClickHandler)
    }
    return () => {
      if (dismissible && onClick) {
        document.body.removeEventListener('click', onClickHandler)
      }
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.right = ''
      document.body.style.left = ''
    }
  }, [dismissible, onClick, onClickHandler])
  return (
    <div ref={popover} className={styles.overlay} style={{ zIndex: zIndex }}>
      {children}
    </div>
  )
}
